// Components always needed in the application layout (navigation, notifications)
import { defineAsyncComponent } from 'vue'

export default {
  Navigation: defineAsyncComponent(() => import('../navigation/index.vue')),
  NavSelector: defineAsyncComponent(
    () => import('../navigation/nav_selector.vue')
  ),
  NotificationTray: defineAsyncComponent(
    () => import('../notifications/notification_tray.vue')
  ),
  NotificationBell: defineAsyncComponent(
    () => import('../notifications/notification_bell.vue')
  ),
  LoginForm: defineAsyncComponent(() => import('../navigation/login_form.vue')),
  ResetPasswordForm: defineAsyncComponent(
    () => import('../navigation/reset_password_form.vue')
  )
}
